import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { trackEvent } from "../lib/analytics";

const footerLinkClass = "text-sm landing-footer-link";

export default function Footer() {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <footer className="yimnak-shell-footer border-t py-14 landing-footer">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-10 mb-10">
          <div className="col-span-1 md:col-span-2">
            <Link
              to="/"
              className="yimnak-shell-footer__brand text-2xl font-bold mb-4 inline-block opacity-90 hover:opacity-100 transition-opacity"
            >
              {t("brand.name")}
            </Link>
            <p className="yimnak-shell-footer__subtitle max-w-sm text-sm leading-relaxed">
              {t("hero.subtitle")}
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4">
              {t("footer.product")}
            </h4>
            <ul className="space-y-2">
              {[
                { to: "/", label: t("nav.home") },
                { to: "/services", label: t("nav.services") },
                { to: "/pricing", label: t("nav.pricing") },
                { to: "/#features", label: t("nav.features") },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    className={footerLinkClass}
                    onClick={() => {
                      if (to === "/pricing")
                        trackEvent("pricing_click", { page: location.pathname, metadata: { place: "footer", target: to } });
                    }}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">
              {t("footer.company")}
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/contact"
                  className={footerLinkClass}
                  onClick={() =>
                    trackEvent("button_click", {
                      page: location.pathname,
                      metadata: { place: "footer", buttonName: "contact" },
                    })
                  }
                >
                  {t("footer.contact")}
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className={footerLinkClass}>
                  {t("footer.privacy")}
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy#terms"
                  className={footerLinkClass}
                >
                  {t("footer.terms")}
                </Link>
              </li>
              <li>
                <Link to="/login" className={footerLinkClass}>
                  {t("nav.login")}
                </Link>
              </li>
              <li>
                <Link to="/register" className={footerLinkClass}>
                  {t("nav.getStarted")}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="yimnak-shell-footer__divider border-t pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="yimnak-shell-footer__copy text-sm">
            {t("footer.rights")}
          </p>
          <div className="flex gap-6">
            <Link to="/privacy-policy" className={`text-sm ${footerLinkClass}`}>
              {t("footer.privacy")}
            </Link>
            <Link
              to="/privacy-policy#terms"
              className={`text-sm ${footerLinkClass}`}
            >
              {t("footer.terms")}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
